export enum SelectedNav {
	Home = "Home",
	ScreenManager = "ScreenManager",
	Library = "MyLibrary",
	Curation = "StudioAccess",
	Settings = "Settings",
}
